import {
  PHOTO_SESSION_RESCHEDULE_CONFIRM_CLICKED,
  PHOTO_SESSION_RESCHEDULE_SUCCESS_VIEWED,
} from 'containers/IssueReport/Reschedule/types';

import { logWithDefaultProperties } from '../defaultLogger';
import { PAGE_NAMES } from '../constants';

export const handleRescheduleActions = (amplitudeInstance, action) => {
  switch (action.type) {
    case PHOTO_SESSION_RESCHEDULE_CONFIRM_CLICKED:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.RESCHEDULE,
        eventName: 'reschedule_photo_session_confirm_clicked',
        extraProperties: action.extraProperties,
      });
      break;

    case PHOTO_SESSION_RESCHEDULE_SUCCESS_VIEWED:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.RESCHEDULE,
        eventName: 'reschedule_photo_session_success_viewed',
        extraProperties: action.extraProperties,
      });
      break;

    default:
      break;
  }
};

export default handleRescheduleActions;
